// i18n area 'hci' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.lv-LV.meta.json.
import type { enUS } from './hci'

export const lvLV: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph klasteri',
      createButton: 'Izveidot Ceph klasteri',
      emptyTitle: 'Nav neviena pārvaldīta Ceph klastera',
      emptyBody: 'TVirt izvieto Ceph dalībnieku mezglos un ir tā īpašnieks — hiperkonverģenti kopā ar VM slodzi. Jāizveido klasteris: pirmais monitors un tā pārvaldnieks rodas automātiski izvēlētajā vadības mezglā — pēc tam to var audzēt ar citiem monitoriem un OSD ierīcēm.',
      pageTitle: 'Ceph klasteri',
      colState: 'Stāvoklis',
      colMembers: 'Dalībnieki',
      colSize: 'Izmērs',
      colVersion: 'Ceph versija',
      sizeCell: 'izmantoti {used} GiB no {total} GiB kopā',
      phase: {
        'not-deployed': 'Nav izvietots',
        deploying: 'Notiek izvietošana',
        healthy: 'Labā stāvoklī',
        degraded: 'Degradēts',
        error: 'Kļūda',
        destroying: 'Notiek iznīcināšana',
        destroyed: 'Iznīcināts'
      },
      health: {
        HEALTH_OK: 'Labā stāvoklī (HEALTH_OK)',
        HEALTH_WARN: 'Ar brīdinājumiem (HEALTH_WARN)',
        HEALTH_ERR: 'Kļūdas stāvoklī (HEALTH_ERR)',
        unknown: 'Vēl nav novērota',
        observedAt: 'novērota {time}'
      },
      create: {
        title: 'Izveidot Ceph klasteri',
        info: 'Veidojot jaunu Ceph klasteri, jāizvēlas pirmais mezgls, kurā tiks uzstādītas MON un MGR lomas. Jānorāda arī, kurš apakštīkls nesīs Ceph datplūsmu: public apakštīkls tiek izmantots vispārējai tīkla datplūsmai, bet cluster apakštīkls — iekšējām replikām starp OSD; atsevišķi apakštīkli nav obligāti.',
        controlNode: 'Vadības mezgls',
        controlNodeHint: 'Dalībnieka mezgls, kurā rodas pirmais MON + MGR.',
        publicSubnet: 'Public apakštīkls',
        publicSubnetHint: 'IPAM reģistrēts apakštīkls — Ceph public_network. Pēc izveides nemaināms.',
        clusterSubnet: 'Cluster apakštīkls',
        clusterSubnetHint: 'IPAM reģistrēts apakštīkls — Ceph cluster_network (replikācija/backfill).',
        noSubnets: 'Nav neviena reģistrēta apakštīkla — tie vispirms jāizveido IPAM',
        sameSubnet: 'Viens un tas pats apakštīkls public un cluster datplūsmai',
        sameSubnetHint: 'Atzīmēts = klastera tīkls (replikācija/backfill) sakrīt ar public. Neatzīmēts = jāizvēlas tā apakštīkls UN vadības mezgla adrese tajā.',
        controlAddress: 'Vadības mezgla adrese',
        controlAddressHint: 'Adrese, ko IPAM zina šim mezglam public apakštīklā.',
        controlClusterAddress: 'Vadības mezgla cluster adrese',
        controlClusterAddressHint: 'Adrese, ko IPAM zina šim mezglam cluster apakštīklā.',
        noAddresses: 'IPAM nezina nevienu šī mezgla adresi izvēlētajā apakštīklā',
        started: 'Klasteris izveidots — bootstrap turpinās kā makrotask; fāze atjaunojas pati',
        error: 'Klasteris tika noraidīts'
      },
      detail: {
        actions: 'Pieejamās darbības',
        tabOverview: 'Pārskats',
        tabManagementNodes: 'MON un MGR',
        tabDisks: 'OSD',
        tabPools: 'Pūli',
        tabObjects: 'Objekti',
        tabCrush: 'CRUSH karte',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Papildu',
        phase: 'Fāze',
        checksTitle: 'Aktīvās veselības pārbaudes',
        noChecks: 'Nav nevienas aktīvas veselības pārbaudes',
        checkMuted: 'apklusināta',
        summaryPools: 'Pūli',
        summaryFilesystems: 'Failu sistēmas',
        nodesCard: 'Mezgli',
        monHint: 'Katram MON līdzās darbojas viens MGR. Trīs MON ir ieteicamais kvorums; laboratorijas klasteris sākas ar vienu. OSD un MDS mīt savās cilnēs.',
        monHintSplit: 'MON un MGR šajā klasterī ir atdalīti (Papildu): katra loma ir sava dalība katram mezglam. Trīs MON ir ieteicamais kvorums; jāpastāv vismaz vienam MGR.',
        noMons: 'Nav deklarēts neviens monitors',
        addNode: 'Pievienot mezglu',
        removeNode: 'Noņemt mezglu',
        removeNodeFrom: 'Noņemt mezglu {node} (tā MON un līdzās izvietoto MGR)',
        roleMon: 'MON loma',
        roleMgr: 'MGR loma',
        roleNa: 'N/A',
        roleNotObserved: 'vēl nav novērota',
        monInQuorum: 'kvorumā',
        monOutQuorum: 'ārpus kvoruma',
        mgrActive: 'aktīvs',
        mgrStandby: 'gaidstāvē',
        addRoleMon: 'Pievienot MON lomu',
        removeRoleMon: 'Noņemt MON lomu',
        addRoleMgr: 'Pievienot MGR lomu',
        removeRoleMgr: 'Noņemt MGR lomu',
        restartMon: 'Pārstartēt MON pakalpojumu',
        restartMgr: 'Pārstartēt MGR pakalpojumu',
        addMon: 'Pievienot MON',
        removeMon: 'Noņemt MON',
        removeMonFrom: 'Noņemt MON lomu no {node}',
        addMgr: 'Pievienot MGR',
        removeMgr: 'Noņemt MGR',
        removeMgrFrom: 'Noņemt MGR lomu no {node}',
        addMds: 'Pievienot MDS',
        removeMds: 'Noņemt MDS',
        removeMdsFrom: 'Noņemt MDS lomu no {node}',
        mdsSection: 'Metadatu serveri (MDS)',
        noMds: 'Nav deklarēts neviens MDS — failu sistēmai vispirms vajadzīgs viens',
        mdsHint: 'MDS dalība ir patstāvīga no pirmās dienas: klasteris bez CephFS nedeklarē nevienu, bet viens aktīvs plus viens gaidstāvē labi apkalpo vienu failu sistēmu. Ceph pats izvēlas aktīvos un gaidstāves dēmonus no deklarētajiem.',
        mdsActiveFor: 'aktīvs — {fs}',
        mdsNotObserved: 'vēl nav novērots',
        lastMdsGuard: 'Pēdējo MDS nevar noņemt, kamēr pastāv kāda failu sistēma — vispirms jānoņem failu sistēmas',
        lastMonGuard: 'Pēdējo MON nevar noņemt — vienīgā izeja ir iznīcināt klasteri',
        lastMgrGuard: 'Pēdējo MGR nevar noņemt — pārvaldīts klasteris nekad nedarbojas bez pārvaldnieka',
        registerDevice: 'Pievienot OSD',
        unregisterDevice: 'Atreģistrēt',
        activeDeviceGuard: 'Aktīvs OSD — tas iziet caur OSD dzīves ciklu, nevis no reģistra',
        colNode: 'Mezgls',
        devicePhase: { registered: 'Reģistrēta', active: 'Aktīva' },
        health: 'Veselība',
        state: 'Stāvoklis',
        fsid: 'fsid',
        fsidPending: 'nav — jāmēģina bootstrap vēlreiz',
        version: 'Ceph versija',
        publicNetwork: 'Public tīkls',
        clusterNetwork: 'Cluster tīkls',
        clusterNetworkCollapsed: '= public',
        noActions: 'Šajā fāzē nav pieejama neviena darbība',
        destroyedNote: 'Klasteris iznīcināts — rinda drīz tiks noņemta automātiski'
      },
      overview: {
        services: 'Pakalpojumi',
        ok: 'labā stāvoklī',
        warning: 'brīdinājums',
        down: 'nedarbojas',
        pgTitle: 'PG stāvokļi',
        pgTotal: 'kopā {n} PG',
        capacityTitle: 'Vieta',
        ioTitle: 'Pašreizējais I/O',
        ioReadBw: 'Lasīšanas caurlaidspēja',
        ioWriteBw: 'Rakstīšanas caurlaidspēja',
        ioReadIops: 'Lasīšanas IOPS',
        ioWriteIops: 'Rakstīšanas IOPS',
        notObserved: 'vēl nav novērots'
      },
      osd: {
        colId: 'ID',
        colClass: 'Ierīces klase',
        colState: 'Stāvoklis',
        colSize: 'Izmērs',
        colPgs: 'PG',
        empty: 'Nav neviena OSD — jāpievieno kāds no deklarēta datu diska',
        markIn: 'Atzīmēt kā IN',
        markOut: 'Atzīmēt kā OUT',
        scrub: 'Veikt scrub',
        deepScrub: 'Veikt dziļo scrub',
        restart: 'Pārstartēt pakalpojumu',
        details: 'Detaļas',
        actionGuard: 'Tikai izvietota klastera aktīvam OSD',
        inTitle: 'Atzīmēt OSD kā IN',
        inBody: 'osd.{id} atgriežas datu izkliedē (ceph osd in): Ceph uz to pārbalansē datus.',
        outTitle: 'Atzīmēt OSD kā OUT',
        outBody: 'osd.{id} iziet no datu izkliedes (ceph osd out): tā dati pārbalansējas citur, un redundance ir SAMAZINĀTA, kamēr norit backfill. Jebkurā brīdī atgriezenisks ar Atzīmēt kā IN.',
        scrubTitle: 'Plānot scrub',
        scrubBody: 'Tiek ieplānots osd.{id} scrub: MON to noliek rindā, un nākamo aptauju PG stāvokļi pastāsta iznākumu.',
        deepScrubTitle: 'Plānot dziļo scrub',
        deepScrubBody: 'Tiek ieplānots osd.{id} dziļais scrub: variants, kas pārbauda baitus — smagāks I/O ziņā, tā pati mehānika.',
        restartTitle: 'Pārstartēt OSD pakalpojumu',
        restartBody: 'osd.{id} tiek apturēts un pārstartēts caur tā mezgla worker uzraudzību.',
        started: 'Darbība sākta — novērojums atjaunojas pats',
        error: 'OSD darbība tika noraidīta'
      },
      osdDetail: {
        title: 'OSD detaļas',
        tabGeneral: 'Vispārīgi',
        tabNetwork: 'Tīkls',
        tabDevices: 'Ierīces',
        version: 'Versija',
        hostname: 'Hosta nosaukums',
        dataPath: 'OSD datu ceļš',
        objectStore: 'OSD objektu glabātuve',
        encrypted: 'Šifrēts',
        yes: 'Jā',
        no: 'Nē',
        memory: 'Atmiņas lietojums (PSS)',
        pid: 'Procesa ID (PID)',
        front: 'Front adrese (klienti un monitori)',
        hbFront: 'Heartbeat front adrese',
        back: 'Back adrese (OSD)',
        hbBack: 'Heartbeat back adrese',
        colDevice: 'Ierīce',
        colType: 'Tips',
        colPhysical: 'Fiziskā ierīce',
        colSize: 'Izmērs',
        volumeTitle: 'Sējuma detaļas',
        creationTime: 'Izveides datums',
        lvName: 'LV nosaukums',
        lvPath: 'LV ceļš',
        lvUuid: 'LV UUID',
        vgName: 'VG nosaukums',
        noDevices: 'Šim OSD nav novērota neviena ierīce'
      },
      restart: {
        title: 'Pārstartēt pakalpojumu',
        monBody: 'MON dēmons mezglā {node} tiek apturēts un pārstartēts caur worker uzraudzību.',
        mgrBody: 'MGR dēmons mezglā {node} tiek apturēts un pārstartēts caur worker uzraudzību.',
        started: 'Pārstartēšana sākta — novērojums atjaunojas pats',
        error: 'Pārstartēšana tika noraidīta'
      },
      encryptionMode: {
        alwaysOn: 'Vienmēr ieslēgta (dmcrypt)',
        alwaysOff: 'Vienmēr izslēgta',
        perOsd: 'Izvēle katram OSD',
        section: 'OSD šifrēšana miera stāvoklī',
        title: 'Mainīt OSD šifrēšanas režīmu',
        hint: 'Kā tiek sagatavoti JAUNIE OSD. Esošie OSD patur savu stāvokli katram diskam: lai to mainītu, OSD jānoņem un jāizveido no jauna.',
        body: 'Režīms kļūst "{mode}" un attiecas TIKAI uz JAUNIEM OSD: katrs esošais OSD patur savu pašreizējo šifrēšanas stāvokli.',
        apply: 'Mainīt režīmu',
        error: 'Režīma maiņa tika noraidīta'
      },
      pin: {
        address: 'Public adrese (neobligāts pin)',
        clusterAddress: 'Cluster adrese (neobligāts pin)',
        autoPlaceholder: 'automātiski apakštīklā {cidr}',
        hint: 'Adresācija katram dēmonam: tukšs = Ceph pats piesaistās deklarētajā tīklā; aizpildīts = šī instance tiek piesprausta šai adresei savā konfigurācijas sadaļā.'
      },
      addMon: {
        title: 'Pievienot mezglu',
        node: 'Mezgls',
        address: 'Public adrese',
        addressHint: 'Mezgla adreses, ko IPAM zina public apakštīklā — automātiski, ja mezglu jau sedz kāda esoša deklarācija.',
        clusterAddress: 'Cluster adrese',
        clusterAddressHint: 'Obligāta: cluster apakštīkls ir atsevišķs, un mezgls tajā vēl nav deklarēts.',
        noAddresses: 'IPAM nezina nevienu šī mezgla adresi šajā apakštīklā',
        error: 'MON pievienošana tika noraidīta'
      },
      removeMon: {
        title: 'Noņemt MON',
        body: 'MON un tā līdzās izvietotais MGR pamet mezglu {node}. Izvietotā klasterī dēmoni tiek apturēti un izņemti no kvoruma.',
        error: 'MON noņemšana tika noraidīta'
      },
      addMgr: {
        title: 'Pievienot MGR',
        node: 'Mezgls',
        hint: 'Papildu iestatījums (atdalīti MON/MGR): patstāvīgs pārvaldnieks rodas izvēlētajā dalībnieka mezglā ar mezglam piesaistītu task. Ceph aktīvā/gaidstāves vēlēšanas pašas nosaka aktīvo MGR.',
        error: 'MGR pievienošana tika noraidīta'
      },
      removeMgr: {
        title: 'Noņemt MGR',
        body: 'Patstāvīgais MGR pamet mezglu {node}. Izvietotā klasterī dēmons tiek apturēts un tā stāvoklis noņemts; mezgla MON (ja tāds ir) netiek aiztikts.',
        error: 'MGR noņemšana tika noraidīta'
      },
      addMds: {
        title: 'Pievienot MDS',
        node: 'Mezgls',
        hint: 'CephFS metadatu serveris: tas rodas izvēlētajā dalībnieka mezglā ar mezglam piesaistītu task, un to uzrauga worker tāpat kā MON un MGR. Ceph pats izvēlas aktīvos un gaidstāves dēmonus — viens aktīvs plus viens gaidstāvē labi apkalpo vienu failu sistēmu.',
        error: 'MDS pievienošana tika noraidīta'
      },
      removeMds: {
        title: 'Noņemt MDS',
        body: 'MDS pamet mezglu {node}. Izvietotā klasterī dēmons tiek apturēts un tā stāvoklis noņemts; API noraida pēdējā MDS noņemšanu, kamēr tas vajadzīgs kādai failu sistēmai.',
        error: 'MDS noņemšana tika noraidīta'
      },
      split: {
        title: 'Atdalīti MON/MGR',
        label: 'Atļaut MON un MGR atsevišķos mezglos',
        hint: 'Izslēgts (noklusējums) = ratificētais standarts: katram MON līdzās darbojas viens MGR, viena vienīga dalība. Ieslēgts = MGR dalība kļūst patstāvīga un tiek pārvaldīta ar darbībām Pievienot/Noņemt MGR pārvaldības mezglu cilnē.',
        enable: 'Ieslēgt',
        disable: 'Izslēgt',
        enableBody: 'MGR dalība kļūst neatkarīga no MON, inicializēta no pašreizējās līdzāsizvietošanas. Darbības Pievienot/Noņemt MGR aktivizējas pārvaldības mezglu cilnē. Tas atslābina platformas noklusējumu — jāpatur tikai tad, ja ir skaidrs, kāpēc tas vajadzīgs.',
        disableBody: 'Atgriešanās pie standarta līdzāsizvietošanas: viens MGR pie katra MON, viena vienīga dalība. Likumīgi tikai tad, ja MGR dalība jau sakrīt ar MON — vispirms tā jāsaskaņo ar Pievienot/Noņemt MGR, citādi API noraidīs.',
        error: 'Izmaiņa tika noraidīta'
      },
      rawEditor: {
        title: 'Neapstrādātais CRUSH redaktors',
        label: 'Rādīt neapstrādāto crushmap redaktoru CRUSH cilnē',
        hint: 'Izslēgts (noklusējums) = vadītā noteikumu virsma ir standarta rīks. Ieslēgts = CRUSH cilne rāda arī dekompilēto crushmap kā rediģējamu tekstu. Saglabāšana vienmēr prasa sudo un klastera nosaukumu kā apstiprinājumu un iet caur crushtool compile + test PIRMS tā sasniedz klasteri.'
      },
      osdFlags: {
        section: 'Globālie OSD karodziņi',
        title: 'OSD karodziņu manuāla pārrakstīšana',
        notObserved: 'vēl nav novēroti',
        standardFlowsHint: 'Platformas standarta plūsmas parastajos gadījumos šos karodziņus pārvalda pašas (mezgla apkope iestata mērķētu noout, diska nomaiņa iet caur OSD dzīves ciklu). Šī sadaļa ir manuālā pārrakstīšana operatoram, kurš zina, ko dara.',
        notDeployedGuard: 'OSD karodziņi pastāv tikai izvietotā klasterī',
        set: 'Iestatīt karodziņu',
        unset: 'Noņemt karodziņu',
        setBody: 'Globālais karodziņš {flag} tiks IESTATĪTS osdmap. Tas paliek, līdz to noņem tieši — aizmirsts karodziņš degradē klastera pašatjaunošanos.',
        unsetBody: 'Globālais karodziņš {flag} tiks NOŅEMTS no osdmap.',
        error: 'Karodziņa izmaiņa tika noraidīta',
        flag: {
          noout: 'Neviens OSD netiek atzīmēts kā out no datu izkliedes — nekādas pārbalansēšanas, zaudējot dēmonu',
          norebalance: 'Datu pārbalansēšana ir apturēta',
          nobackfill: 'Backfill ir apturēts',
          norecover: 'Atkopšana ir apturēta',
          pause: 'VISS klientu I/O ir pauzēts (lasīšana un rakstīšana)',
          noin: 'OSD, kas startē, netiek automātiski atzīmēti kā in',
          nodown: 'Nesasniedzamie OSD netiek atzīmēti kā down — tas maskē īstus bojājumus'
        }
      },
      pools: {
        section: 'Pūli',
        create: 'Izveidot pūlu',
        createGuard: 'Pūli pastāv tikai izvietotā klasterī',
        notObserved: 'Nav neviena pūlu novērojuma — šeit ziņo MON aptauja',
        empty: 'Klasterī nav neviena pūla',
        colName: 'Nosaukums',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Lietojums',
        colRule: 'CRUSH noteikums',
        colUsage: 'Izmantojums',
        observedAtLabel: 'Novērots',
        objects: '{n} objekti',
        inUseBy: 'lieto {name}',
        internalGuard: 'Ceph iekšējais pūls — platforma to nekad nedzēš',
        delete: 'Dzēst pūlu',
        deleteGuard: 'To patērē storage {name} — vispirms jādzēš storage',
        hint: 'Tikai replicēti pūli (erasure coding ir ārpus v1 scope). Replikācija dzīvo Ceph: šī tabula ir MON aptaujas novērotā patiesība.',
        createTitle: 'Izveidot pūlu',
        createHint: 'Pūls rodas klasterī ar pieprasīto replikāciju un ieslēgtu rbd lietojumu — darbu veic task uz MON mezgla. Jāieslēdz "Piedāvāt kā storage", lai to uzreiz patērētu tajā pašā žestā.',
        name: 'Pūla nosaukums',
        nameHint: 'DNS-drošs (mazie burti, cipari, defises).',
        size: 'Replikas (size)',
        sizeHint: 'Katra objekta kopijas. Noklusējums 3.',
        minSize: 'Minimālās replikas (min_size)',
        minSizeHint: 'Minimālais kopiju skaits, lai apkalpotu I/O — seko size − 1, kamēr netiek mainīts.',
        createError: 'Pūla izveide tika noraidīta',
        deleteTitle: 'Dzēst pūlu',
        deleteBody: 'Pūls {pool} un KATRS objekts tajā tiek neatgriezeniski iznīcināts. Lai apstiprinātu, jāieraksta pūla nosaukums.',
        confirmLabel: 'Pūla nosaukums',
        confirmHint: 'Lai apstiprinātu, jāieraksta pūla nosaukums',
        deleteError: 'Pūla dzēšana tika noraidīta',
        detailTitle: 'Pūla detaļas',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktīvs',
        autoscalerOff: 'Nav aktīvs',
        autoscalerWarn: 'Paziņojums',
        pgNumLabel: 'PG skaits',
        pgNumCaption: 'Novērots: autoscaler to var mainīt patstāvīgi — šis lauks pieraksta vēlmi.',
        storage: 'Saistītais TVirt storage',
        addAsStorage: 'Pievienot kā TVirt storage',
        ruleSudoHint: 'CRUSH noteikuma maiņa prasa operatora paroli.',
        updateError: 'Pūla izmaiņa tika noraidīta',
        updated: 'Pūla izmaiņa sākta — novērojums atjaunojas pats'
      },
      crush: {
        section: 'CRUSH noteikumi',
        notObserved: 'Vēl nav neviena CRUSH novērojuma — šeit ziņo MON aptauja',
        empty: 'Klasterī nav novērots neviens noteikums',
        hint: 'Noteikums izlemj, KUR nonāk katra objekta kopijas — tā bojājuma domēns ir vienība, kas var atteikt, nezaudējot datus. Pūli norāda uz noteikumu; iebūvētais replicated_rule (viena replika katram serverim) ir noklusējums no dzimšanas.',
        create: 'Izveidot noteikumu',
        createGuard: 'CRUSH noteikumi pastāv tikai izvietotā klasterī',
        createTitle: 'Izveidot CRUSH noteikumu',
        createHint: 'Viens noteikums = viena bojājuma domēna izvēle. Noteikums rodas replicēts uz noklusējuma root — darbu veic task uz MON mezgla; pūlus tam piesaista pēc tam Pūlu cilnē.',
        createError: 'Noteikuma izveide tika noraidīta',
        name: 'Noteikuma nosaukums',
        nameHint: 'DNS-drošs (mazie burti, cipari, defises).',
        domain: 'Bojājuma domēns',
        domainChoice: {
          osd: 'Katra replika citā OSD',
          host: 'Katra replika citā serverī',
          rack: 'Katra replika citā rack'
        },
        domainCustom: 'Pielāgots (ar roku rakstīti soļi)',
        domainOther: 'Katra replika citā {type}',
        rackGuardHint: 'Novērotajā hierarhijā nav neviena rack bucket: noteikumu var izveidot tik un tā, taču neviens pūls uz to nevarēs norādīt, kamēr rack nav deklarēts dalībnieku serveru novietojumā (mezgla iestatījumos) — saskaņošanas task uzbūvē bucket, un piesaiste atveras pati.',
        treeTitle: 'Novērotā hierarhija',
        treeNotObserved: 'Nav neviena hierarhijas novērojuma — šeit ziņo MON aptauja',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH karte tā, kā to redz klasteris: root → deklarētie līmeņi → serveris (host) → OSD. Topoloģija seko katra servera deklarētajam novietojumam (mezgla iestatījumi) — novietojuma maiņa to saskaņo ar task.',
        unplacedWarning: 'Dalībnieki bez deklarēta novietojuma: {nodes} — to hosti paliek tieši zem root, ārpus deklarētās topoloģijas. Novietojums jādeklarē mezgla iestatījumos (brīdinājums, nekad bloķēšana).',
        colName: 'Nosaukums',
        colDomain: 'Bojājuma domēns',
        colPools: 'Pūli',
        builtinChip: 'iebūvēts',
        builtinGuard: 'Klastera noklusējuma noteikums — platforma to nekad nedzēš',
        detailAction: 'Noteikuma detaļas',
        detailType: 'Tips',
        backToRules: 'Noteikumi',
        ruleNotObserved: 'Novēroto noteikumu sarakstā šis noteikums nav minēts',
        noPools: 'Neviens pūls neizmanto šo noteikumu',
        delete: 'Dzēst noteikumu',
        deleteTitle: 'Dzēst CRUSH noteikumu',
        deleteBody: 'Noteikums {rule} tiek noņemts no klastera crushmap. Neviens pūls to nedrīkst izmantot. Lai apstiprinātu, jāieraksta noteikuma nosaukums.',
        deleteGuard: 'To izmanto pūls {name} — vispirms jāpārvirza pūls',
        confirmLabel: 'Noteikuma nosaukums',
        confirmHint: 'Lai apstiprinātu, jāieraksta noteikuma nosaukums',
        deleteError: 'Noteikuma dzēšana tika noraidīta',
        changeRule: 'Mainīt CRUSH noteikumu',
        changeRuleTitle: 'Mainīt CRUSH noteikumu',
        changeRuleHint: 'Pūls sāk izvietot savus objektus pēc izvēlētā noteikuma — Ceph pārvieto esošos datus, lai tie tam atbilstu (pilnā pūlā tam seko pārbalansēšana).',
        changeRuleError: 'Noteikuma maiņa tika noraidīta',
        rule: 'CRUSH noteikums',
        rawTitle: 'Neapstrādāta crushmap (dekompilēta)',
        rawWarning: 'BĪSTAMI: šis teksts ir VISA klastera novietojuma politika. Nepareiza karte var salauzt visu pūlu novietojumu uzreiz. Saglabāšana kompilē un pārbauda karti ar crushtool PIRMS tās injicēšanas — taču arī derīga karte var būt slikta doma.',
        rawReload: 'Pārlādēt',
        rawLoading: 'Vaicājums ceļā — tikai lasāms task dekompilē crushmap…',
        rawSave: 'Saglabāt crushmap',
        rawSaveTitle: 'Injicēt crushmap',
        rawSaveBody: 'Mainītais teksts pēc crushtool compile + test aizstāj VISA klastera crushmap. Lai apstiprinātu, jāieraksta klastera nosaukums.',
        rawConfirmLabel: 'Klastera nosaukums',
        rawConfirmHint: 'Lai apstiprinātu, jāieraksta {name}',
        rawError: 'Darbība ar crushmap neizdevās',
        rawHint: 'Teksts ir crushtool -d forma. Kompilēšanas un testa kļūdas atgriežas vārds vārdā no crushtool — karte nesasniedz klasteri, ja kaut viens no abiem vārtiem neizdodas.'
      },
      objects: {
        poolsSection: 'Objektu pārlūks',
        poolsHint: 'Jāizvēlas pūls, lai uzskaitītu tā RBD attēlus. Katra dziļā lasīšana norit kā tikai lasāms task uz MON mezgla — tā nebloķē reālās darbības un netiek no tām bloķēta.',
        deployedGuard: 'Objektu vaicājumi atbild tikai izvietotā klasterī',
        browse: 'Pārlūkot objektus',
        detailAction: 'Attēla detaļas',
        backToPools: 'Pūli',
        backToImages: 'Attēli',
        refresh: 'Atjaunināt',
        loading: 'Vaicājums ceļā — tikai lasāms task aptaujā klasteri…',
        error: 'Vaicājums neizdevās',
        retry: 'Mēģināt vēlreiz',
        notRbd: 'Pūls ar lietojumu "{app}" — tas nesatur RBD attēlus, šeit nav ko pārlūkot',
        noImages: 'Šajā pūlā nav neviena RBD attēla',
        colImage: 'Attēls',
        colSize: 'Izmērs',
        colObjects: 'Objekti',
        colSnapshots: 'Snapshot',
        imagesHint: 'Diski uz patērējoša rbd storage ir attēli ar sava diska id nosaukumu. Objektu skaits ir piešķirtais (izmērs / objekta izmērs) — reālais lietojums mīt attēla detaļās.',
        infoTitle: 'Attēls',
        infoSize: 'Virtuālais izmērs',
        infoObjects: 'Objekti (piešķirti)',
        infoObjectSize: 'Objekta izmērs',
        infoPrefix: 'Objektu prefikss',
        infoFormat: 'Formāts',
        infoFeatures: 'Iespējas',
        usageTitle: 'Reālais lietojums (rbd du)',
        usageOf: 'no {provisioned} GiB piešķirtajiem',
        usageHint: 'Thin pēc savas dabas: baitus aizņem tikai ierakstītie objekti.',
        watchersTitle: 'Watcher',
        noWatchers: 'Nav neviena watcher — neviens šo attēlu pašlaik nav atvēris',
        snapshotsTitle: 'RBD snapshot',
        noSnapshots: 'Šim attēlam nav neviena RBD snapshot',
        colSnapshot: 'Snapshot',
        colProtected: 'Aizsargāts',
        colTimestamp: 'Izveidots',
        protected: 'aizsargāts',
        mappingTitle: 'Fiziskais kartējums (OSD kopa)',
        mappingSampled: 'Izlase: {sampled} objekti no {total} — godīgs kopsavilkums: lieliem attēliem kopa saplūst ar VISIEM pūla OSD (CRUSH izkliedē objektus pa visu pūlu).',
        mappingComplete: 'Visi objekti kartēti ({total} no {total}).',
        objectQueryTitle: 'Kartēt vienu objektu',
        objectName: 'Objekta nosaukums',
        objectHint: 'RADOS objektu nosaukumi ir <prefikss>.<16-hex indekss> — ceph osd map atbild ar PG un OSD trijniekiem.',
        mapObject: 'Kartēt',
        primary: 'primārais: osd.{osd}'
      },
      registerDevice: {
        title: 'Reģistrēt OSD ierīci',
        hint: 'Dzīvā klasterī reģistrācija ierīci arī SAGATAVO: tā kļūst par BlueStore OSD ar automātisku, mezglam piesaistītu task (nekad tukša, ratificēts 2026-07-24). Ierīce pieder ne vairāk kā vienam Ceph klasterim visā flotē.',
        disk: 'Datu disks',
        diskHint: 'Mezgla deklarētie datu diski — nosaukums un sērijas numurs',
        noDeclared: 'Šajā mezglā nav deklarēts neviens datu disks — tie vispirms jāatzīmē mezgla lokālajos iestatījumos',
        serialHint: 'Ierīces sērijas numurs — identitātes pin',
        encrypted: 'Šifrēt šo OSD (dmcrypt)',
        encryptedHint: 'Izvēle katram OSD (klastera režīms ir "izvēle katram OSD"): tā iesalst uz šī diska reģistrācijas brīdī — vēlāka režīma maiņa to nekad nepārraksta; to dara rindas darbība šifrēt/atšifrēt.',
        error: 'Reģistrācija tika noraidīta'
      },
      unregisterDevice: {
        title: 'Atreģistrēt ierīci',
        body: 'Tikai reģistrs: {name} pārstāj būt šī klastera OSD kandidāts. Tās baiti netiek aiztikti.',
        error: 'Atreģistrēšana tika noraidīta'
      },
      deploy: {
        action: 'Mēģināt izvietošanu vēlreiz',
        title: 'Mēģināt bootstrap vēlreiz',
        body: 'Dzimšanas bootstrap sākas no jauna ar pašreizējo konfigurāciju: MON startē, katra reģistrētā ierīce tiek sagatavota un aktivizēta kā BlueStore OSD. Darbība norit kā makrotask — fāze atjaunojas pati.',
        started: 'Bootstrap sākts — turpinās kā makrotask; fāze atjaunojas pati',
        error: 'Bootstrap tika noraidīts'
      },
      propose: {
        action: 'Piedāvāt kā storage',
        title: 'Piedāvāt kā storage',
        hintPool: 'Esošais pūls {name} kļūst par TVirt storage: keystore nonāk ar šo pūlu ierobežota cephx identitāte, un ceph-rbd storage rodas gatavs. Piedāvājums pūlu patērē — tas nekad nevienu neizveido.',
        hintFs: 'Esošā failu sistēma {name} kļūst par TVirt storage: keystore nonāk ar šo failu sistēmu ierobežota cephx identitāte, un cephfs storage rodas gatavs un montēts. Piedāvājums failu sistēmu patērē — tas nekad nevienu neizveido.',
        name: 'Storage nosaukums',
        nameHint: 'DNS-1123, unikāls scope ietvaros — cephx identitāte ņem nosaukumu no tā.',
        path: 'Ceļš failu sistēmas iekšienē',
        pathHint: 'Absolūts ceļš failu sistēmā, ko storage montē — šaubu gadījumā /.',
        alsoPropose: 'Uzreiz piedāvāt kā storage',
        alsoProposePoolHint: 'Pēc izveides tas pats žests piedāvā tikko radīto pūlu kā ceph-rbd storage — divi skaidri izsaukumi, viens vienīgs dialogs.',
        alsoProposeFsHint: 'Pēc izveides tas pats žests piedāvā tikko radīto failu sistēmu kā cephfs storage — divi skaidri izsaukumi, viens vienīgs dialogs.',
        guard: 'Piedāvāt kā storage — tikai labā stāvoklī esošam klasterim',
        started: 'Piedāvājums pieņemts — storage materializējas; tas atrodams sadaļā Storage',
        submit: 'Izveidot storage',
        error: 'Piedāvājums tika noraidīts'
      },
      fs: {
        section: 'Failu sistēmas',
        create: 'Izveidot failu sistēmu',
        createGuard: 'Failu sistēmas pastāv tikai izvietotā klasterī',
        mdsFirstGuard: 'Vispirms jāpievieno MDS — failu sistēma bez metadatu servera rodas nelietojama',
        notObserved: 'Nav neviena failu sistēmu novērojuma — šeit ziņo MON aptauja',
        empty: 'Klasterī nav nevienas failu sistēmas',
        colName: 'Nosaukums',
        colPools: 'Pūli',
        colMds: 'MDS',
        noActiveMds: 'nav neviena aktīva MDS',
        delete: 'Noņemt failu sistēmu',
        deleteGuard: 'To patērē storage {name} — vispirms jādzēš storage',
        hint: 'Failu sistēmai pieder savi datu un metadatu pūli (cephfs.<nosaukums>.data / .meta): tie rodas kopā ar to un mirst kopā ar to — removeFs, nekad pūla dzēšana ar roku. Šī tabula ir MON aptaujas novērotā patiesība.',
        createTitle: 'Izveidot failu sistēmu',
        createHint: 'Failu sistēma rodas klasterī ar saviem diviem pūliem (lietojums cephfs), un to apkalpo deklarētie MDS — darbu veic task uz MON mezgla. Jāieslēdz "Piedāvāt kā storage", lai to uzreiz patērētu tajā pašā žestā.',
        name: 'Failu sistēmas nosaukums',
        nameHint: 'DNS-drošs (mazie burti, cipari, defises).',
        sizeHint: 'ABU topošo pūlu replikas. Noklusējums 3.',
        createError: 'Failu sistēmas izveide tika noraidīta',
        deleteTitle: 'Noņemt failu sistēmu',
        deleteBody: 'Failu sistēma {fs} un KATRS fails tajā tiek neatgriezeniski iznīcināts — tās datu un metadatu pūli mirst kopā ar to. Lai apstiprinātu, jāieraksta failu sistēmas nosaukums.',
        confirmLabel: 'Failu sistēmas nosaukums',
        confirmHint: 'Lai apstiprinātu, jāieraksta failu sistēmas nosaukums',
        deleteError: 'Failu sistēmas noņemšana tika noraidīta'
      },
      destroy: {
        action: 'Iznīcināt',
        retryAction: 'Mēģināt dzēšanu vēlreiz',
        retryGuard: 'Iznīcināšana norit — atkārtojums attiecas uz neizdevušos iznīcināšanu (citādi lease to noraida)',
        title: 'Iznīcināt klasteri',
        body: 'Izvietotais fabric tiek nojaukts: katrs šī klastera dēmons apstājas, tā sistēmas stāvoklis un atslēgas keystore tiek atbrīvotas. Pēc veiksmīgas iznīcināšanas klasteris tiek noņemts automātiski.',
        confirmLabel: 'Klastera nosaukums',
        confirmHint: 'Lai apstiprinātu, jāieraksta klastera nosaukums',
        wipe: 'Notīrīt reģistrētās ierīces',
        wipeHint: 'Atzīmēts: katras reģistrētās ierīces paraksti tiek dzēsti — dati uz tām tiek iznīcināti. Neatzīmēts: baiti paliek neskarti un ierīces atgriežas reģistrētas.',
        guard: 'Iznīcināt — nekas nav izvietots',
        started: 'Iznīcināšana sākta — turpinās kā makrotask; fāze atjaunojas pati',
        error: 'Iznīcināšana tika noraidīta'
      },
      delete: {
        guard: 'Dzēst — tikai neizvietotu konfigurāciju (vispirms jāiznīcina)',
        title: 'Vai dzēst {name}?',
        body: 'Konfigurācija un tās ierīču reģistrs tiek noņemti. Likumīgi tikai tik ilgi, kamēr nekas nav izvietots.',
        error: 'Dzēšana tika noraidīta'
      }
    }
  }
}
